/* eslint-disable @typescript-eslint/no-explicit-any */ export function memoizeForHalfSecond(builder) {
    let memoized = null;
    return (...args)=>{
        if (!memoized) {
            // eslint-disable-next-line no-return-assign
            setTimeout(()=>memoized = null, 500);
            memoized = builder(...args);
        }
        return memoized;
    };
}

//# sourceMappingURL=memoizeForHalfSecond.js.map